import React, { Component, PropTypes } from 'react';
import Icon from './Icon';

export default class ModuleDownload extends Icon {
  render() {
    let { color, size, viewPortSize, className, ...props } = this.props;

    return (
      <svg
        width={size}
        height={size}
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        x="0px"
        y="0px"
        viewBox={'0 0 ' + viewPortSize + ' ' + viewPortSize}
        {...props}
      >
        <g fill={color}>
          <path
            d="M8.3,12.7v-5H7.7v5l-1.5-1.1l-0.4,0.5l2,1.5c0.1,0,0.1,0.1,0.2,0.1s0.1,0,0.2-0.1l2-1.5l-0.4-0.5L8.3,12.7z
          "
          />
          <path
            d="M12.7,5.9c-0.1-2-1.8-3.5-3.8-3.5c-1.4,0-2.7,0.8-3.4,2.1C5.3,4.4,5.1,4.3,4.9,4.3C3.5,4.3,2.3,5.5,2.3,7
          c0,0.1,0,0.3,0,0.4c-1,0.1-1.7,0.9-1.7,1.9c0,1,0.9,1.9,1.9,1.9h2.9v-0.6H2.5c-0.7,0-1.3-0.6-1.3-1.3c0-0.7,0.6-1.3,1.3-1.3h0.2
          L3,7.6C2.9,7.4,2.9,7.2,2.9,7c0-1.1,0.9-2,2-2c0.2,0,0.5,0,0.7,0.1L6,4.9C6.5,3.7,7.6,3,8.9,3c1.8,0,3.2,1.4,3.2,3.2l0,0l0.3,0.3
          c0.1,0,0.2,0,0.3,0c1.1,0,2,0.9,2,2c0,1.1-0.9,2-2,2h-2.2v0.6h2.2c1.4,0,2.6-1.2,2.6-2.6C15.4,7.1,14.2,5.9,12.7,5.9z"
          />
        </g>
      </svg>
    );
  }
}



// WEBPACK FOOTER //
// ./src/js/components/Icons/ModuleDownload.js